import * as React from 'react';

import Text from '../../../../text/Text.jsx';

export type SurveyResultContainerProps = {
  topline: React.ReactNode;
  headline: React.ReactNode;
  children?: React.ReactNode;
};

const SurveyResultContainer = ({
  topline,
  headline,
  children
}: SurveyResultContainerProps) => (
  <div className="survey-result-container">
    <Text className="survey-result-container__topline" variant="copy" tag="h4">
      {topline}
    </Text>
    <Text className="survey-result-container__headline" variant="copy-bold">
      {headline}
    </Text>
    {children}
  </div>
);

export default SurveyResultContainer;
